import React from "react";
import { FormGroup, Label, Input } from "reactstrap";
import { formOptions } from "./constants";

const PersonalInfo = ({ formData, handleChange, errors }) => {
  return (
    <>
      <FormGroup>
        <Label for="statusrumah">Status Rumah</Label>
        <Input 
          type="select" 
          name="statusrumah" 
          id="statusrumah" 
          value={formData.statusrumah} 
          onChange={handleChange}
        >
          <option value="">Pilih</option>
          {formOptions.statusRumah.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.statusrumah && <div className="invalid-feedback">{errors.statusrumah}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="nomorUrut">1. Nomor Blok</Label>
        <Input 
          type="number" 
          name="nomorUrut" 
          id="nomorUrut" 
          value={formData.nomorUrut || ""} 
          onChange={handleChange} 
          className={errors.nomorUrut ? "is-invalid" : ""}  
        />
        {errors.nomorUrut && <div className="invalid-feedback">{errors.nomorUrut}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="nomorRumahPadaPeta">2. Nomor Peta</Label>
        <Input 
          type="number" 
          name="nomorRumahPadaPeta" 
          id="nomorRumahPadaPeta" 
          value={formData.nomorRumahPadaPeta || ""} 
          onChange={handleChange} 
          className={errors.nomorRumahPadaPeta ? "is-invalid" : ""}  
        />
        {errors.nomorRumahPadaPeta && <div className="invalid-feedback">{errors.nomorRumahPadaPeta}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="namaLengkapKK">3. Nama Lengkap KK</Label>
        <Input 
          type="text" 
          name="namaLengkapKK" 
          id="namaLengkapKK" 
          value={formData.namaLengkapKK} 
          onChange={handleChange} 
          className={errors.namaLengkapKK ? "is-invalid" : ""}
        />
        {errors.namaLengkapKK && <div className="invalid-feedback">{errors.namaLengkapKK}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="tanggallahir">4. Tanggal lahir</Label>
        <Input
          type="text"
          name="tanggallahir"
          id="tanggallahir"
          value={formData.tanggallahir}
          onChange={handleChange}
          disabled={formData.statusrumah === "Tidak Berpenghuni"}
          placeholder="DD/MM/YYYY"
        />
        {errors.tanggallahir && (
          <div className="invalid-feedback">{errors.tanggallahir}</div>
        )}
      </FormGroup>

      <FormGroup>
        <Label for="jenisKelamin">5. Jenis Kelamin</Label>
        <Input 
          type="select" 
          name="jenisKelamin" 
          id="jenisKelamin" 
          value={formData.jenisKelamin}  
          className={errors.jenisKelamin ? "is-invalid" : ""} 
          disabled={formData.statusrumah === "Tidak Berpenghuni"}
          onChange={handleChange}
        >
          <option value="">Pilih</option>
          {formOptions.jenisKelamin.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.jenisKelamin && <div className="invalid-feedback">{errors.jenisKelamin}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="nomorKK">6. Nomor KK</Label>
        <Input 
          type="text" 
          name="nomorKK" 
          id="nomorKK" 
          value={formData.nomorKK || ""} 
          onChange={handleChange} 
          disabled={formData.statusrumah === "Tidak Berpenghuni"}
          className={` ${errors.nomorKK ? "is-invalid" : ""}`} 
        />
        {errors.nomorKK && <div className="invalid-feedback">{errors.nomorKK}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="nomorKTP">7. Nomor KTP</Label>
        <Input 
          type="number" 
          name="nomorKTP" 
          id="nomorKTP" 
          value={formData.nomorKTP || ""} 
          onChange={handleChange} 
          disabled={formData.statusrumah === "Tidak Berpenghuni"}
          className={` ${errors.nomorKTP ? "is-invalid" : ""}`} 
        />
        {errors.nomorKTP && <div className="invalid-feedback">{errors.nomorKTP}</div>}
      </FormGroup>

      <FormGroup>
        <Label for="asalKTP">8. Asal KTP</Label>
        <Input
          type="select"
          name="asalKTP"
          id="asalKTP"
          value={formData.asalKTP}
          onChange={handleChange}
          disabled={formData.statusrumah === "Tidak Berpenghuni"}
          className={errors.asalKTP ? "is-invalid" : ""}   
        >
          <option value="">Pilih</option>
          {formOptions.asalKTP.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Input>
        {errors.asalKTP && <div className="invalid-feedback">{errors.asalKTP}</div>}
      </FormGroup>
    </>
  );
};

export default PersonalInfo;
